module.exports = __webpack_public_path__ + "static/media/logo_mercado_pago.028fc6fa.png";